import { API, authClient } from "../index";

export const postOperario = async (operario, accessToken) => {
	return authClient(accessToken).post(`${API}/operarios`, operario);
};

export const getOperarios = (accessToken) => {
	return authClient(accessToken).get(`${API}/operarios`);
};

export const getOperarioById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/operarios/${id}`);
};

export const updateOperario = async (id, operario, accessToken) => {
	return authClient(accessToken).put(`${API}/operarios/${id}`, operario);
};

export const updateOperarioStatus = async (id, active, accessToken) => {
	return authClient(accessToken).put(
		`${API}/operarios/${id}/status?active=${active}`
	);
};

export const generateOperarioMobileAccessToken = (id, accessToken) =>
	authClient(accessToken).post(`${API}/operarios/${id}/token-acceso-movil`);
